import { isValidPhoneNumber, parsePhoneNumberFromString } from 'libphonenumber-js';

/** Requires a leading + and a valid international number (E.164-style input). */
export function isValidPhoneNumberInput(raw: string): boolean {
  const trimmed = raw.trim();
  if (!trimmed.startsWith('+')) return false;
  return isValidPhoneNumber(trimmed);
}

/**
 * Returns the normalized E.164 number, or null when the input is missing or invalid.
 * Requires a leading + country prefix.
 */
export function normalizePhoneNumber(raw: string | null | undefined): string | null {
  if (raw == null || !raw.trim()) return null;
  const trimmed = raw.trim();
  if (!trimmed.startsWith('+')) return null;
  try {
    const phone = parsePhoneNumberFromString(trimmed);
    if (!phone?.isValid()) return null;
    return phone.format('E.164');
  } catch {
    return null;
  }
}
